import Element from './elements';
import GuID from './helpers/guid';

class Items {

    constructor() {
        this.nav = '.personalizator__product-image-content-controls>ul>li';
        this.tab = '.personalizator__insert-tab';
        this.activeClass = 'active';

        this.bindChange();
    }

    bindChange() {
        $(document).ready(() => {
            $(this.nav).click((event) => {
                $(this.tab).removeClass(this.activeClass);
                $(this.nav).removeClass(this.activeClass);

                $(event.currentTarget).addClass(this.activeClass);
                $($(event.currentTarget).data('tab')).addClass(this.activeClass);

                let data;
                let tab = $(event.currentTarget);
                let id = GuID.uuidv4();

                if(tab.data('type') !== 'img') {
                    data = {
                        type: tab.data('type'),
                        id: `#${id}`,
                        name: id,
                        font: '',
                        size: 16,
                        color: '',
                        inputText: tab.data('input-text'),
                        inputSize: tab.data('input-size'),
                        inputFont: tab.data('input-font'),
                        inputColor: tab.data('input-color'),
                        tab: tab.data('tab'),
                        tabType: tab.data('tab-type'),
                        value: ''
                    }
                } else {
                    data = {
                        type: 'img',
                        id: `#${id}`,
                        name: id,
                        tab: tab.data('tab'),
                        input: tab.data('input'),
                        inputAttachment: tab.data('input-attachment'),
                        attachments: [],
                        tabType: tab.data('tab-type'),
                        value: ''
                    };
                }

                let element = new Element(data, tab.data('content'));

                if(data.type !== 'img') {
                    element.createElement();
                    $(data.inputText).focus();
                } else {
                    $(data.tab).find(data.input).click();
                }

            });
        });
    }

    get name() {

        reutrn 

    }

}

export const items = new Items();
